import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import StepperItem from "./StepperItem";
import { guardActions } from "../store/guardSlice";
import stepper from "../Utilities/stepperUtil";
import appConst from "../Utilities/appConst.json";

const CustomStepper = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [steps, setSteps] = useState(
    [...Array(props.size).keys()].map((key) => ({ id: key }))
  );
  const stepperIndex = useSelector((state) => state.guard.guardIndex);
  const isError = useSelector((state) => state.error.isError);
  const isBasketEmpty = useSelector((state) => state.error.isBasketEmpty);
  const isNewsletter = useSelector((state) => state.user.isNewsletter);
  const isBirthdayDate = useSelector((state) => state.user.isBirthdayDate);
  const showHeader = useSelector((state) => state.mode.showHeader) === "true";
  const language = useSelector((state) => state.mode.language);
  const direction = useSelector((state) => state.mode.direction);
  const product = sessionStorage.getItem(appConst.PRODUCT); //appConst.ORDERS_UNION
  const orderedSteps =
    language === "en" ? steps : [...steps].reverse();

  useEffect(() => {
    if (stepperIndex === -1) {
      location.pathname = "";
    }
  }, []);

  useEffect(() => {
    if (isError) {
      location.pathname = appConst.TWELTH_PAGE;
    }
  }, [isError]);

  useEffect(() => {
    if (isBasketEmpty) {
      location.pathname = appConst.THIRTEEN_PAGE;
    }
  }, [isBasketEmpty]);

  useEffect(() => {
    if ((isNewsletter && isBirthdayDate) || product == appConst.ORDERS_UNION) {
      dispatch(guardActions.setGuardIndex(stepper.get(0)));
    }
  }, [isNewsletter, isBirthdayDate]);

  return (
    <>
      {stepperIndex >= 0 && (
        <div className="stepper">
          <div
            className="fixed z-[2] flex w-full flex-row justify-between gap-[2.3px] bg-white md:gap-[3px]"
            style={showHeader ? { top: "56px" } : { top: 0 }}
            dir={direction}
          >
            {orderedSteps.map((labal, index) => {
              return (
                <StepperItem
                  index={stepperIndex}
                  number={index}
                  key={labal.id}
                ></StepperItem>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default CustomStepper;
